import { useEffect, useRef, useState } from 'react';

const useToggleFullScreen = () => {
    const [isFullScreen, setFullScreen] = useState(false);
    const isFullScreenRef = useRef(isFullScreen);

    const toggleFullScreen = () => {
        J.ng.togglePageBodyFullscreen().then((isFullScreenRes) => {
            setFullScreen(isFullScreenRes);
        });
    };

    useEffect(() => {
        isFullScreenRef.current = isFullScreen;
    }, [isFullScreen]);

    useEffect(() => {
        const _isFullScreen = isFullScreenRef;
        return () => {
            if (_isFullScreen.current) {
                toggleFullScreen();
            }
        };
    }, []);

    return {
        isFullScreen,
        toggleFullScreen,
    };
};

export default useToggleFullScreen;
